<template>
  <div>
    <v-btn
      v-if="$route.query.migrate"
      :disabled="loading"
      @click="createCategories"
      class="btn-save"
    >
      <i class="fas fa-check mr-2 text-twenty"></i>
      {{ loading ? "CARREGANDO" : "IMPORTAR CATEGORIAS" }}
    </v-btn>
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="create"
      title="NOVA CATEGORIA"
    >
      <Create @success="paginate" />
    </b-modal>
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="import"
      title="IMPORTAR CATEGORIA(S)"
    >
      <Import @success="paginate" />
    </b-modal>
    <div class="row">
      <div class="col-md-12 border">
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pb-0">
            <h1 class="title-pages">CATEGORIAS</h1>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 text-right pb-0"
          >
            <v-btn
              v-if="permission('write', 'financial_category')"
              @click="$bvModal.show('create')"
              class="btn-add m-1"
              ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
            >
            <v-btn
              v-show="false"
              @click="$bvModal.show('import')"
              class="btn-dateils m-1"
              ><i class="fas fa-file-upload mr-2 text-twenty"></i> IMPORTAR
              CATEGORIA(S)</v-btn
            >
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0">
            <h6>O que são categorias?</h6>
            <p class="worksansr text-justify">
              Categoria financeira
              <b
                >é a forma mais correta de organizar suas receitas e despesas no
                Sistema Clin</b
              >. Com ela sua empresa pode extrair estatísticas de gastos em
              determinada categoria. Como por exemplo: saber quanto representa a
              folha de pagamento sobre suas despesas mensais, ou até cortar
              gastos em uma determinada categoria.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="input-group">
              <input
                v-model="search"
                type="text"
                class="form-control"
                placeholder="Pesquisar..."
              />
              <div
                class="
                  input-group-pprend
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <v-btn disabled><i class="fas fa-search" /></v-btn>
              </div>
            </div>
          </div>
        </div>
        <b-overlay :show="loading" opacity="0.99">
          <div
            class="v-clean p-5 text-center"
            v-show="
              recipe.length == 0 && expense.length == 0 && mixed.length == 0
            "
          >
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <div
            v-show="recipe.length > 0 || expense.length > 0 || mixed.length > 0"
          >
            <v-treeview
              :items="items"
              :search="search"
              :filter="filter"
              open-on-click
              :open.sync="open"
            >
              <template v-slot:prepend="{ item }">
                <div
                  :style="`width: 15px !important;height: 15px !important;${
                    item.color
                      ? `background-color: ${item.color}`
                      : 'background-color: #34495E'
                  }`"
                />
              </template>
              <template v-slot:append="{ item }">
                <div v-if="item.default == 0">
                  <span>
                  <i :class="[
                    'fas fa-circle',
                    item.status == 1 ? 'color-green' : 'color-warning',
                  ]"></i>
                  {{ item.status == 1 ? "ATIVO" : "INATIVO" }}</span>

                  <b-modal
                    size="lg"
                    no-close-on-backdrop
                    hide-footer
                    :id="`edit-${item.id}`"
                    :title="`EDITAR CATEGORIA: ${item.name}`"
                  >
                    <Edit @success="paginate" :data="item" />
                  </b-modal>
                  <v-btn
                    v-if="permission('edit', 'financial_category')"
                    x-small
                    class="v-primary"
                    @click="edit(item)"
                    >EDITAR</v-btn
                  >
                </div>
              </template>
            </v-treeview>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import Create from "./Categories/Create";

import Edit from "./Categories/Edit";

import Import from "./Categories/Import";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import permission from "../../../lib/permission";

export default {
  name: "Categories",

  components: {
    Create,
    Edit,
    Import,
  },

  data() {
    return {
      recipe: [],
      expense: [],
      mixed: [],
      text: "",
      loading: false,

      items: [],

      open: [],
      search: null,
      caseSensitive: false,
    };
  },

  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : null;
    },
  },

  created() {
    this.paginate();
  },

  methods: {
    permission,

    async paginate() {
      try {
        this.loading = true;

        let { text } = this;

        let params = { text };

        const response = await api.get(
          "/rest-home/financial/configuration/category",
          { params }
        );

        const { recipe, expense, mixed } = response.data;

        this.recipe = recipe;
        this.expense = expense;
        this.mixed = mixed;

        this.items = [
          {
            id: 1,
            name: "Categorias de ganhos",
            default: 1,
            color: "#4CAF50",
            children: recipe,
          },
          {
            id: 2,
            name: "Categorias de gastos",
            default: 1,
            color: "#FF5252",
            children: expense,
          },
          {
            id: 3,
            name: "Categorias sem classificação",
            default: 1,
            color: "#1F5A76",
            children: mixed,
          },
        ];

        if (this.open.length == 0) {
          this.open = [1, 2, 3];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    edit(parent) {
      this.$bvModal.show(`edit-${parent.id}`);
    },

    async createCategories() {
      try {
        this.loading = true;

        const response = await api.post(
          "/rest-home/financial/configuration/category/import"
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.paginate();
          toast(message);
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
